<ng-container *ngIf="attachments.length >= 1">
  <span class="fake-link text-uppercase" (click)="isOpen = !isOpen">
    {{ attachments.length }} Attachment{{ attachments.length > 1 ? 's' : '' }}
    <i class="fa fa-angle-down"></i>
  </span>
  <div class="position-relative">
    <ul *ngIf="isOpen">
      <li *ngFor="let item of attachments" class="text-truncate pointer" (click)="downloadFile(item)" [title]="item.fileName">
        <i class="fa fa-{{item.fileType?.className}}" [ngStyle]="{'color': item.fileType?.color}"></i>
        {{item.fileName}}
      </li>
    </ul>
  </div>
</ng-container>
